import React, { forwardRef } from 'react';
import { KanaInfo } from './data';

interface KanaCellProps {
    kana: KanaInfo;
    onClick: (kana: KanaInfo) => void;
    isSelected: boolean;
    showRomaji: boolean;
    correspondingKana?: string;
}

export const KanaCell = forwardRef<HTMLDivElement, KanaCellProps>(
    ({ kana, onClick, isSelected, showRomaji, correspondingKana }, ref) => {
        return (
            <div
                ref={ref}
                className={`gojuon-cell ${kana.type} ${isSelected ? 'selected' : ''}`}
                onClick={() => onClick(kana)}
            >
                <div className="atomic-number">{kana.atomic}</div>
                <div className="kana-main">{kana.kana}</div>
                <div className="kana-sub-left">{correspondingKana}</div>
                <div className="kana-sub-right">{showRomaji ? kana.romaji : ''}</div>
            </div>
        );
    }
);

KanaCell.displayName = 'KanaCell';
